module.exports = __webpack_public_path__ + "img/Speaker=Talia Kennedy.e5734ed9.png";